import { useEffect, useState } from "react";
import { api } from "../lib/utils";

export const useGetAllSubCategories = (category) => {
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    if (category) {
      getAllSubCategoriesCategoriesWise();
    }
  }, [category]);

  const getAllSubCategoriesCategoriesWise = async () => {
    try {
      const encodedCategory = encodeURIComponent(category);
      const result = await api.get(
        `/api/categories/getSubCategories?category_name=${encodedCategory}`,
      );
      if (result) {
        setSubCategories(result?.data);
      }
    } catch (err) {
      return err;
    }
  };

  return subCategories;
};
